import React, { useEffect, useState } from "react";
import { FiBook, FiWatch, FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import { useCookies } from "react-cookie";
import axios from "axios";
import $ from "jquery";

import "../css/users.css";
import { FiHome } from "react-icons/fi";

import HeaderSearchBar from "../components/headerSearchBar";

export default function Users() {

    const [cookies, setCookie, removeCookie, removeCookies] = useCookies(["userPuuId"]);

    let { id } = useParams();

    const [ username, setUsername ] = useState("");
    const [ socialname, setSocialName ] = useState("");
    const [ bio, setBio ] = useState("");

    useEffect(() => {
        axios.get(`https://cloudify-backend.herokuapp.com/users/get/byid/${id}`)
        .then(resp => {
            var data = resp.data;
            var userInfo = resp.data.userInfo;

            var libraryId = userInfo.libraryId;

            setUsername(userInfo.username);
            setSocialName(userInfo.socialname);
            document.getElementById("userPicture").src = userInfo.profilePicture;

            if(data.userInfo.bio) setBio(userInfo.bio)
            else {
                setBio("Adicione a sua bio aqui")
            }

            if(libraryId) {
                document.getElementById("libraryVisitButton").href = `/libraries/${libraryId}`;
            }
            else {
                var button = document.getElementById("createLibrary");
                document.getElementById("libraryVisitButton").hidden = true;
                button.hidden = false;
                button.href = `/create/library/${id}`;
            }

            document.getElementById("seeHistory").href = `/history/${id}`
        })
    }, []);

    function imageInputClick() {
        axios.get(`https://cloudify-backend.herokuapp.com/functions/generateandreplacepfp/${id}`)
        .then(resp => {
            if(resp.data.sucesso == true) {
                window.location.reload();
            }
            else return false;
        })
    }

    function bioChange(event) {
        event.preventDefault()

        axios.post(`https://cloudify-backend.herokuapp.com/users/changebio/${id}`, {
            "bio":bio
        })
        .then(resp => {
            if(resp.data.sucesso == true) window.location.reload()
            else setBio("Erro ao alterar sua bio 😪")
        })
    }

    function logout() {
        document.cookie.split(";").forEach((c) => {
            document.cookie = c
              .replace(/^ +/, "")
              .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        window.location.href = '/';
    }

    return (
        <div className="app">

            <HeaderSearchBar />

            <div className="centered">
                <div id="userForm">

                    <Link to="/" > <FiHome style={{"color":"white", "fontSize":"32px"}} /> </Link>

                    <div id="userInfoHandler">

                        <div className="centered">
                            <h3 id="usernameDisplayer">@{username}</h3>
                        </div>

                        <div className="centered">
                            <img src="https://i.ibb.co/px3GVFk/icon-rounded.png" onClick={imageInputClick} id="userPicture" />
                        </div>

                        <div className="centered">
                            <a onClick={logout} id="logoutButton" > <h2>Sair</h2> </a>
                        </div>

                        <div className="centered">
                            <h1>{socialname}</h1>
                        </div>

                        <div className="centered" id="bioText">
                            <form onSubmit={bioChange}>

                                <input id="bioInput" onChange={(key) => { setBio(key.target.value) }} value={bio} maxLength="40" />

                            </form>
                        </div>

                        {/* <div className="centered">
                            <div id="editReadingStatuses">

                                <div id="bookInfoDisplayer">
                                    <img src="http://books.google.com/books/content?id=FP-rXfdk7EoC&printsec=frontcover&img=1&zoom=1&edge=curl&imgtk=AFLRE73XFaTQSCAIOPLDyKkAvkk6prLLrZoqDpVNz7Bx5alNsZ1_0Bo1DnQix8QR7fs3-Y6FvF4egQu1yg44cvpHT9BlIjt16_oMzhoerdXUgp5BvE-U3-l2CsGq7TLIYMKLoYSpXky3&source=gbs_api" />

                                    <div id="infoDisplayer">
                                        <h1>Percy Jackson - O ladrão de raios</h1>

                                        <div className="centered">
                                            <h1 id="pageReadingTitle">Já li até a página</h1>
                                        </div>

                                        <div className="centered">
                                            <div id="pageCounting">
                                                <input placeholder="O livro tem 375 páginas" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="centered">
                                    <div className="progress" id="progressBar">
                                        <div className="progress-value" id="progessBarLoading"></div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    <div className="centered">
                        <div id="holdUserFunctions">
                            <a id="libraryVisitButton">
                                <div id="userFunctionButton">
                                    <h1> <FiBook /> </h1>
                                    <h2>Ver minha biblioteca</h2>
                                </div> 
                            </a>

                            <a id="createLibrary" hidden>
                                <div id="userFunctionButton">
                                    <h1> <FiPlus /> </h1>
                                    <h2>Criar minha biblioteca</h2>
                                </div> 
                            </a>

                            <a id="seeHistory">

                                <div id="userFunctionButton">
                                    <h1> <FiWatch /> </h1>
                                    <h2>Ver meu histórico</h2>
                                </div> 

                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}